import React from 'react'

import { BaseLogo, LogoVariantComponent } from './BaseLogo'
import { LOGO_NAMES, THEMED_LOGO_NAMES } from './logos/constants'

export type LogoComponent = LogoVariantComponent & {
  Afterpay: LogoVariantComponent
  Clearpay: LogoVariantComponent
  AfterpayByCashapp: LogoVariantComponent
}

export const Logo: LogoComponent = (props) => {
  return <BaseLogo {...props} />
}

const Afterpay: LogoVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Logo name={LOGO_NAMES.AFTERPAY} {...otherProps} />
}

const Clearpay: LogoVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Logo name={LOGO_NAMES.CLEARPAY} {...otherProps} />
}

const AfterpayByCashapp: LogoVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Logo name={THEMED_LOGO_NAMES.CASHAPP_AFTERPAY} {...otherProps} />
}

Logo.displayName = 'Logo'
Afterpay.displayName = 'Logo.Afterpay'
Clearpay.displayName = 'Logo.Clearpay'
AfterpayByCashapp.displayName = 'Logo.AfterpayByCashapp'

Logo.Afterpay = Afterpay
Logo.Clearpay = Clearpay
Logo.AfterpayByCashapp = AfterpayByCashapp
